export class HsAnalyticsComponent {
  container;

  prevClickedElement;

  constructor() {
    this.container = document.querySelector('body');
  }

  initialize() {
    if (!this.container) {
      return;
    }

    this.addEventListeners();

    setInterval(() => {
      this.setButtonIds();
    }, 200);
  }

  addEventListeners() {
    const analyticsElements = [...this.container.querySelectorAll('.js-hs-analytics')];
    analyticsElements.forEach((analyticsElement) => {
      analyticsElement.addEventListener('click', (e) => this.analyticsElementClickHandler(e));
    });

    const elementorAnalyticButtons = [...this.container.querySelectorAll('.js-elementor-modal-wrapper')];
    elementorAnalyticButtons.forEach((elementorAnalyticButton) => {
      elementorAnalyticButton.addEventListener('click', (e) => this.elementorAnalyticButtonClickHandler(e));
    });
  }

  analyticsElementClickHandler(e) {
    this.prevClickedElement = e.target;
  }

  elementorAnalyticButtonClickHandler(e) {
    const target = e.target.closest('.js-elementor-modal-wrapper');
    if (!target) {
      return;
    }

    const textElement = target.querySelector('.elementor-button-text');
    if (textElement) {
      this.prevClickedElement = textElement;
    }
  }

  getNameByTarget(target) {
    if (!target) {
      return '';
    }

    if (target.closest('.resource-list__item')) {
      return 'Resource grid item';
    }

    if (target.closest('.js-elementor-modal-wrapper')) {
      return target.innerHTML;
    }

    return '';
  }

  setButtonIds() {
    if (!this.prevClickedElement) {
      return;
    }

    const name = this.getNameByTarget(this.prevClickedElement);

    const inputs = [...document.querySelectorAll('.hbspt-form input[name=button_id]')];
    inputs.forEach((input) => {
      input.value = name;
    });
  }
}